import { create } from "zustand";
import { persist } from "zustand/middleware";

interface ActiveContextState {
	activeCanteiroId: string | null;
	setActiveCanteiro: (id: string | null) => void;
	activeObraId: string | null;
	setActiveObra: (id: string | null) => void;
	setActive: (canteiroId: string | null, obraId: string | null) => void;
	reset: () => void;
}

export const useActiveContext = create<ActiveContextState>()(
	persist(
		(set) => ({
			activeCanteiroId: null,
			setActiveCanteiro: (activeCanteiroId) => set({ activeCanteiroId }),
			activeObraId: null,
			setActiveObra: (activeObraId) => set({ activeObraId }),
			setActive: (activeCanteiroId, activeObraId) =>
				set({ activeCanteiroId, activeObraId }),
			reset: () => set({ activeCanteiroId: null, activeObraId: null }),
		}),
		{ name: "otd-context" },
	),
);
